export function checkLitros(cantidad) {
    if(cantidad>=0){
        return true;
    }
    else{
        return false;
    }
  };